define('services/auditLocalizeService',[
    'lib/lodash4',
    'lib/knockout',
    'text!strings/auditActions.json'
], function (_,
             ko,
             unprocessedAuditActions
    ) {
    'use strict';

    var auditActions,
        auditEntities,
        auditProperties;


    /**
     * Gets the localized strings for all audit actions
     *
     * @returns {*}
     */
    var getAllAuditActions = function () {
        if (!auditActions) {

            auditActions = _.map(JSON.parse(unprocessedAuditActions).auditActions, function (auditAction) {
                return {
                    displayString: ko.i18n.renderString(auditAction.key),
                    action:        auditAction.action
                };
            });
        }

        return auditActions;
    };


    /**
     * Gets the localized strings for all audit entities
     *
     * @returns {*}
     */
    var getAllAuditEntities = function () {
        if (!auditEntities) {

            auditEntities = _.map(JSON.parse(unprocessedAuditActions).auditEntities, function (auditEntity) {
                return {
                    displayString: ko.i18n.renderString(auditEntity.key),
                    entity:        auditEntity.entity
                };
            });
        }

        return auditEntities;
    };


    /**
     * Gets the localized strings for all audit properties
     *
     * @returns {*}
     */
    var getAllAuditProperties = function () {
        if (!auditProperties) {

            auditProperties = _.map(JSON.parse(unprocessedAuditActions).auditProperties, function (auditProperty) {
                return {
                    displayString: ko.i18n.renderString(auditProperty.key),
                    property:      auditProperty.property
                };
            });
        }

        return auditProperties;
    };


    /**
     * Gets the localized string for a specific audit action
     *
     * @param auditAction - the audit action
     * @returns {*}
     */
    var getAuditAction = function (auditAction) {
        return _.find(getAllAuditActions(), {  action: auditAction  });
    };


    /**
     * Gets the localized string for a specific audit entity
     *
     * @param auditEntity - the audit entity
     * @returns {*}
     */
    var getAuditEntity = function (auditEntity) {
        return _.find(getAllAuditEntities(), {  entity: auditEntity  });
    };


    /**
     * Gets the localized string for a specific audit property
     *
     * @param auditProperty - the audit property
     * @returns {*}
     */
    var getAuditProperty = function (auditProperty) {
        return _.find(getAllAuditProperties(), {  property: auditProperty  });
    };


    var auditLocalizeService =  {

        /**
         * Gets the localized string for an audit action
         *
         * @param auditAction - the audit action
         * @returns {*}
         */
        getLocalizedAuditAction: function (auditAction) {
            var localizedAuditAction =  getAuditAction(auditAction.toUpperCase());

            return localizedAuditAction ? localizedAuditAction.displayString : ko.i18n.renderString("audit.action.unknown");
        },


        /**
         * Gets the localized string for an audit entity
         *
         * @param auditEntity - the audit entity
         * @returns {*}
         */
        getLocalizedAuditEntity: function (auditEntity) {
            var localizedAuditEntity =  getAuditEntity(auditEntity.toUpperCase());

            return localizedAuditEntity ? localizedAuditEntity.displayString : ko.i18n.renderString("audit.action.unknown");
        },


        /**
         * Gets the localized string for an audit property
         *
         * @param auditProperty - the audit property
         * @returns {*}
         */
        getLocalizedAuditProperty: function (auditProperty) {
            var localizedAuditProperty =  getAuditProperty(auditProperty.toUpperCase());

            return localizedAuditProperty ? localizedAuditProperty.displayString : ko.i18n.renderString("audit.action.unknown");
        }
    };

    return auditLocalizeService;
});

